export const RED_CENTRE_SEARCH_TILE_POSITION = 3
export const RED_CENTRE_SEARCH_TILE_URL = '/au/campaign/red-centre'

const RED_CENTRE_SEARCH_TILE_DESTINATION_IDS: ReadonlySet<string> = new Set([
  'le_3bc31a430954d8326605fc690ed22f4d',
  'le_f43f1e548bda32da028fd8fa526667b2',
  'le_562665876813fa22c782a16245091b88',
  'le_b045675b79f27d42ec3ecabb731cac94',
  'le_7a1aca7f192c9a7df2cf92ce7f80849f',
  'le_0b6de0afb1c052325b8c0db73c11274b',
  'le_7b4b11ed889380f69fa94ad1e8823f49',
  'le_c87868f0f71f3895ea79f1a1970cf097',
  'le_c55a1998f8016b7b5c6f96595b9ca1ba',
  'le_3dbcdd4e3bb124d22b5ef20f565c1e15',
  'le_3f08f0e6992e8d712984a799e6681209',
  'le_0a7184747218c4cb31e983ab19d01dab',
  'le_61474bcc24de42921bebc645b8301cdf',
  'le_b052886e8eb66444f97a32124b0d30f6',
  'le_7dfaea4a180e7bd5826bce7dec1cdcba',
  'le_95e6834d0a3d99e9ea8811855ae9229d',
  'le_12e48aad7e98c9a576a69cfd36074685',
  'le_d3b357941a0c5a604230132d47ee25f9',
  'le_7aeb4e41ab937c6c935669d7054b1846',
])

export function isRedCentreSearchTileEligible(
  destinationId: string | undefined,
  searchType: App.SearchItem['searchType'],
  region: string,
): boolean {
  return region === 'AU' && searchType === 'destination' &&
    !!destinationId && RED_CENTRE_SEARCH_TILE_DESTINATION_IDS.has(destinationId)
}
